import React from 'react';
import { imageUrl } from '../../../lib/index';
import useRewriteUrl from '../../../hooks/useRewriteUrl';
import SlideMarketPrices from './SlideMarketPrices';

function MarketPricesByCatalogue({ data, tab = '' }) {
  useRewriteUrl();
  return (
    <div className="inline-block">
      {data &&
        data.map((catalogue, index) =>
          catalogue.list_market_prices && catalogue.list_market_prices.length > 0 ? (
            <div key={catalogue.id} className="card col-12 mb-2 pt-2">
              <div className="list-inline-item form-control-range">
                <div className="ml-2">
                  <img
                    src={imageUrl(catalogue.image)}
                    className="rounded-circle image-thumnail box-category"
                    alt="icon category"
                  />
                  <strong className="primary-clr ml-2">{catalogue.name}</strong>
                </div>
              </div>
              <div className="cont-center saved-items">
                <SlideMarketPrices marketPrices={catalogue.list_market_prices} catalogue={catalogue} tab={tab} />
              </div>
            </div>
          ) : null,
        )}
    </div>
  );
}

export default MarketPricesByCatalogue;
